import axios from 'axios';

const API_URL = '/api/lazisnu';

const getLazisnuTransactions = async () => {
  try {
    const response = await axios.get(`${API_URL}/transaksi`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const createPenerimaanInfak = async (transactionData) => {
  try {
    const response = await axios.post(`${API_URL}/transaksi/penerimaan-infak`, transactionData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const createPenerimaanZakat = async (transactionData) => {
  try {
    const response = await axios.post(`${API_URL}/transaksi/penerimaan-zakat`, transactionData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const createPenerimaanDanaAmil = async (transactionData) => {
  try {
    const response = await axios.post(`${API_URL}/transaksi/penerimaan-dana-amil`, transactionData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const createPenyaluran = async (transactionData) => {
  try {
    const response = await axios.post(`${API_URL}/transaksi/penyaluran`, transactionData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const createBebanPengelolaan = async (transactionData) => {
  try {
    const response = await axios.post(`${API_URL}/transaksi/beban-pengelolaan`, transactionData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const updateLazisnuTransaction = async (id, transactionData) => {
  try {
    const response = await axios.put(`${API_URL}/transaksi/${id}`, transactionData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const deleteLazisnuTransaction = async (id) => {
  try {
    await axios.delete(`${API_URL}/transaksi/${id}`);
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const getAkunForLazisnu = async () => {
  try {
    const response = await axios.get(`${API_URL}/akun`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

export {
  getLazisnuTransactions,
  createPenerimaanInfak,
  createPenerimaanZakat,
  createPenerimaanDanaAmil,
  createPenyaluran,
  createBebanPengelolaan,
  updateLazisnuTransaction,
  deleteLazisnuTransaction,
  getAkunForLazisnu,
};